import React from "react";
import { SecondaryCompactButton } from "./secondary-button";

export interface ButtonSelectOption {
    id: string;
    label: string;
    icon?: React.ComponentType<React.ComponentProps<"svg">>;
}

interface ButtonSelectProps {
    options: ButtonSelectOption[];
    selectedIds: string[];
    onToggle: (id: string) => void;
}

export const ButtonSelect: React.FC<ButtonSelectProps> = props => {
    const { options, selectedIds, onToggle } = props;
    return (
        <div className="flex flex-wrap gap-1.5 my-2">
            {options.map(option => {
                const Icon = option.icon;
                return (
                    <SecondaryCompactButton
                        key={option.id}
                        type="button"
                        selected={selectedIds.includes(option.id)}
                        onClick={() => onToggle(option.id)}>
                        <span className="inline-flex items-center gap-1">
                            {Icon ? <Icon className="w-4 h-4" /> : null}
                            {option.label}
                        </span>
                    </SecondaryCompactButton>
                );
            })}
        </div>
    );
};
